module.exports = __webpack_public_path__ + "vrgroup.fe96ecb1c9ea55944138.worker.js"